import toast from "react-hot-toast";

/**
 * Standard toast API. Pair errors with `getApiErrorMessage(err)` from `api`.
 *
 * notify.success(msg) / notify.error(msg) / notify.info(msg)
 * notify.promise(promise, { loading, success, error }) — success/error may be functions of the result/error.
 * notify.dismiss(id?) — dismisses one toast or all.
 */
const notify = {
  success: (message, options) => toast.success(message, options),
  error: (message, options) => toast.error(message, options),
  info: (message, options) => toast(message, options),
  promise: (promise, messages, options) => toast.promise(promise, messages, options),
  dismiss: (id) => toast.dismiss(id),
};

export default notify;
